import AbstractModel from './AbstractModel'
import Mapper from './mapper/Mapper'
import Column from './table/Column'
import DateColumn from './table/DateColumn'

class Collaboratori extends AbstractModel {
  permission () {
    return {
      'USR': {
        action: { isInsertable: true, isEditable: true, isDeletable: true },
        columns: {}
      },
      'ADM': {
        action: { isImpersonate: false, isInsertable: true, isEditable: true, isDeletable: true },
        columns: {}
      }
    }
  }
  mapper () {
    return [
      Mapper.column.azienda(true)
    ]
  }
  columns () {
    return [
      new Column('btn').withHtml(true).withWidth('100px').withIsEditable(false).withIsInsertable(false).withExportable(false),
      new Column('id').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('idazi').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('nome').withType('text').withOnEditDisabled(true),
      new Column('cognome').withType('text').withOnEditDisabled(true),
      new Column('ragsoc').withType('text').withOnEditDisabled(true),
      new Column('indiri').withType('text').withIsVisible(false),
      new Column('cap').withType('number').withIsVisible(false),
      new Column('locali').withType('text').withIsVisible(false),
      new Column('provi').withType('text').withIsVisible(false),
      new Column('telefono').withType('tel').withIsVisible(false),
      new Column('fax').withType('tel').withIsVisible(false),
      new Column('pariva').withType('text').withIsVisible(false),
      new Column('email').withType('email').withIsVisible(false),
      new Column('codfis').withType('text').withIsVisible(false),
      new Column('ambito').withType('text').withIsVisible(false).withOnEditDisabled(true).withOnInsertDisabled(false),
      new DateColumn('dataini'),
      new DateColumn('datafine'),
      new Column('pec').withType('email').withIsVisible(false)
    ]
  }

  validator () {
    return {
      idazi: { required: true, type: 'number' },
      nome: { required: false, type: 'string' },
      cognome: { required: false, type: 'string' },
      ragsoc: { required: true, type: 'string' },
      indiri: { required: false, type: 'string' },
      cap: { required: false, type: 'string' },
      locali: { required: false, type: 'string' },
      provi: { required: false, type: 'string' },
      telefo: { required: false, pattern: /\D*([2-9]\d{2})(\D*)([2-9]\d{2})(\D*)(\d{4})\D*/, message: 'Valore non corretto', trigger: 'blur' },
      dataini: { required: false },
      ambito: { required: true, type: 'string' }
    }
  }
}

export default new Collaboratori()
